import { render, staticRenderFns } from "./onlitdetlist.vue?vue&type=template&id=4de3c716&scoped=true&"
import script from "./onlitdetlist.vue?vue&type=script&lang=js&"
export * from "./onlitdetlist.vue?vue&type=script&lang=js&"
import style0 from "./onlitdetlist.vue?vue&type=style&index=0&id=4de3c716&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de3c716",
  null
  
)

export default component.exports